import Link from 'next/link';
import Image from 'next/image';
import AuthorshipAndLicense from './AuthorshipAndLicense';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookSquare } from '@fortawesome/free-brands-svg-icons/faFacebookSquare';
import { faInstagram } from '@fortawesome/free-brands-svg-icons/faInstagram';
import { faXTwitter } from '@fortawesome/free-brands-svg-icons/faXTwitter';
import { faYelp } from '@fortawesome/free-brands-svg-icons/faYelp';
import { faYoutubeSquare } from '@fortawesome/free-brands-svg-icons/faYoutubeSquare';
import { faTiktok } from '@fortawesome/free-brands-svg-icons/faTiktok';
import { faGoogle } from '@fortawesome/free-brands-svg-icons/faGoogle';
import { faLinkedin } from '@fortawesome/free-brands-svg-icons/faLinkedin';


export default function Footer() {
  return (
    <footer className="footer-container bg-darkBackground text-white pt-12">
      <div className="container mx-auto px-4 plg:t-10 lg:pb-20 lg:px-0 grid grid-cols-1 md:grid-cols-3 gap-8">
        
        {/* About Section */}
        <div className="footer-about text-left">
          <h3 className="text-primary text-xl mb-4">About Us</h3>
          <p className="text-sm uppercase tracking-wide mb-2">License <span className="text-primary">#1159287</span></p>

          <p className="text-white max-w-xs">
            At Modern Build, we specialize in transforming homes to reflect your vision of perfection, ensuring quality craftsmanship and lasting beauty.
          </p>
          <AuthorshipAndLicense />
          <Image src="/modern-build-home-remodeling-logo.webp" alt="Modern Build Best LA'S Home Remodeling Contractor" title="Modern Build Best LA'S Home Remodeling Contractor" width={1489} height={295} className="hidden lg:block mt-10 w-[200px] lg:w-[200px] " />
        </div>

        {/* Quick Links Section */}
        <div className="footer-links">
          <h3 className="text-primary text-xl mb-4">Quick Links</h3>
          <ul className="space-y-2">
            <li>
              <Link href="/about-us" className="footer-link group flex items-center hover:text-primary transition-all duration-500 ease">
                <span className="bg-transparent hidden rounded-full w-2 h-2 transform group-hover:block group-hover:bg-primary transition-all duration-500 ease"></span>
                <span className="text-white group-hover:translate-x-2 transition-all duration-500 ease">About</span>
              </Link>
            </li>
            <li>
              <Link href="/services" className="footer-link group flex items-center hover:text-primary transition-all duration-500 ease">
                <span className="bg-transparent hidden rounded-full w-2 h-2 transform group-hover:block group-hover:bg-primary transition-all duration-500 ease"></span>
                <span className="text-white group-hover:translate-x-2 transition-all duration-500 ease">Services</span>
              </Link>
            </li>
            <li>
              <Link href="/projects" className="footer-link group flex items-center hover:text-primary transition-all duration-500 ease">
                <span className="bg-transparent hidden rounded-full w-2 h-2 transform group-hover:block group-hover:bg-primary transition-all duration-500 ease"></span>
                <span className="text-white group-hover:translate-x-2 transition-all duration-500 ease">Projects</span>
              </Link>
            </li>
            <li>
              <Link href="/blog" className="footer-link group flex items-center hover:text-primary transition-all duration-500 ease">
                <span className="bg-transparent hidden rounded-full w-2 h-2 transform group-hover:block group-hover:bg-primary transition-all duration-500 ease"></span>
                <span className="text-white group-hover:translate-x-2 transition-all duration-500 ease">Blog</span>
              </Link>
            </li>
            <li>
              <Link href="/financing" className="footer-link group flex items-center hover:text-primary transition-all duration-500 ease">
                <span className="bg-transparent hidden rounded-full w-2 h-2 transform group-hover:block group-hover:bg-primary transition-all duration-500 ease"></span>
                <span className="text-white group-hover:translate-x-2 transition-all duration-500 ease">Financing</span>
              </Link>
            </li>
            <li>
              <Link href="/contact" className="footer-link group flex items-center hover:text-primary transition-all duration-500 ease">
                <span className="bg-transparent hidden rounded-full w-2 h-2 transform group-hover:block group-hover:bg-primary transition-all duration-500 ease"></span>
                <span className="text-white group-hover:translate-x-2 transition-all duration-500 ease">Contact</span>
              </Link>
            </li>
            <li>
              <Link href="/service-areas" className="footer-link group flex items-center hover:text-primary transition-all duration-500 ease">
                <span className="bg-transparent hidden rounded-full w-2 h-2 transform group-hover:block group-hover:bg-primary transition-all duration-500 ease"></span>
                <span className="text-white group-hover:translate-x-2 transition-all duration-500 ease">Service Areas</span>
              </Link>
            </li>
            <li>
              <Link href="/sitemap" className="footer-link group flex items-center hover:text-primary transition-all duration-500 ease">
                <span className="bg-transparent hidden rounded-full w-2 h-2 transform group-hover:block group-hover:bg-primary transition-all duration-500 ease"></span>
                <span className="text-white group-hover:translate-x-2 transition-all duration-500 ease">Sitemap</span>
              </Link>
            </li>
            <li>
              <Link href="https://modernbuild.pro" className="footer-link group flex items-center hover:text-primary transition-all duration-500 ease">
                <span className="bg-transparent hidden rounded-full w-2 h-2 transform group-hover:block group-hover:bg-primary transition-all duration-500 ease"></span>
                <span className="text-white group-hover:translate-x-2 transition-all duration-500 ease">Modern Build Pro</span>
              </Link>
            </li>
          </ul>
        </div>

        {/* Contact Information Section */}
        <div className="footer-contact">
          <h3 className="text-primary text-xl mb-4">Contact Us</h3>
          
          {/* Address */}
          <p className="text-white mb-2 flex items-center">
            <MapPin className="w-5 h-5 mr-2 text-primary" />
            4222 Longridge Ave, Studio City, CA 91604, USA
          </p>
          
          {/* Phone Number (Clickable) */}
          <p className="text-white mb-2 flex items-center">
            <Phone className="w-5 h-5 mr-2 text-primary" />
            <a href="tel:+13233004130" className="hover:text-primary">Phone: (323) 300-4130</a>
          </p>

          {/* Email (Clickable) */}
          <p className="text-white mb-2 flex items-center">
            <Mail className="w-5 h-5 mr-2 text-primary" />
            <a href="mailto:remodel@modernbuildremodel.com" className="hover:text-primary">Email: remodel@modernbuildremodel.com</a>
          </p>

          {/* Business Hours */}
          <p className="text-white flex items-center">
            <Clock className="w-5 h-5 mr-2 text-primary" />
            Monday–Sunday: 8:00 am – 9:00 pm
          </p>

          {/* Social Media Icons */}
          <div className="flex space-x-3 mt-4 ml-[2px]">
            <a href="https://www.facebook.com/modernbuildhomeremodeling" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
              <span className="sr-only">Modern Build Home Remodeling Facebook</span>
              <FontAwesomeIcon icon={faFacebookSquare} className="text-primary text-[20px] hover:text-white" />
            </a>
            <a href="https://www.instagram.com/modernbuildhomeremodeling" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
              <span className="sr-only">Modern Build Home Remodeling Instagram</span>
              <FontAwesomeIcon icon={faInstagram} className="text-primary text-[20px] hover:text-white" />
            </a>
            <a href="https://x.com/modernbuildhome" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
              <span className="sr-only">Modern Build Home Remodeling Twitter / X</span>
              <FontAwesomeIcon icon={faXTwitter} className="text-primary text-[20px] hover:text-white" />
            </a>
            <a href="https://www.yelp.com/biz/modern-build-home-remodeling-los-angeles" target="_blank" rel="noopener noreferrer" aria-label="Yelp">
              <span className="sr-only">Modern Build Home Remodeling Yelp</span>
              <FontAwesomeIcon icon={faYelp} className="text-primary text-[20px] hover:text-white" />
            </a>
            <a href="https://www.youtube.com/@modernbuildhomeremodeling" target="_blank" rel="noopener noreferrer" aria-label="YouTube">
              <span className="sr-only">Modern Build Home Remodeling YouTube</span>
              <FontAwesomeIcon icon={faYoutubeSquare} className="text-primary text-[20px] hover:text-white" />
            </a>
            <a href="https://www.tiktok.com/@modernbuildhomeremodel" target="_blank" rel="noopener noreferrer" aria-label="TikTok">
              <span className="sr-only">Modern Build Home Remodeling TikTok</span>
              <FontAwesomeIcon icon={faTiktok} className="text-primary text-[20px] hover:text-white" />
            </a>
            <a href="https://g.co/kgs/5HbGoXf" target="_blank" rel="noopener noreferrer" aria-label="Google">
              <span className="sr-only">Modern Build Home Remodeling Google</span>
              <FontAwesomeIcon icon={faGoogle} className="text-primary text-[20px] hover:text-white" />
            </a>
            <a href="https://www.linkedin.com/company/modern-build-home-remodeling" target="_blank" rel="noopener noreferrer" aria-label="Linkedin">
              <span className="sr-only">Modern Build Home Remodeling Linkedin</span>
              <FontAwesomeIcon icon={faLinkedin} className="text-primary text-[20px] hover:text-white" />
            </a>
          </div>
        </div>
      </div>

      {/* Bottom Section */}
      <div className="bg-footerBackground mt-12 pt-10 pb-10 px-10 lg:flex justify-between items-center text-center text-sm text-white">
        {/* Left Text */}
        <p>&copy; 2025 Modern Build. All rights reserved.</p>

        {/* Right Links */}
        <div className="lg:flex space-x-4">
          <Link href="/privacy-policy" prefetch={false} className="hover:text-primary">
            Privacy Policy
          </Link>
          <Link href="/terms-of-service" prefetch={false} className="hover:text-primary">
            Terms of Service
          </Link>
          <Link href="/privacy-security" prefetch={false} className="hover:text-primary">
            Privacy and Security
          </Link>
        </div>
      </div>
    </footer>
  );
}
